// extracted by mini-css-extract-plugin
export default {"promotionalResourcesContainer":"PromotionalResources_promotionalResourcesContainer__-I5LN"};